var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427322574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427322575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M3.125 7V14",
    stroke: "currentColor",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 35",
    d: "M9.625 9V14",
    stroke: "currentColor",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 34",
    d: "M6.37501 2L6.375 14",
    stroke: "currentColor",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 36",
    d: "M12.875 6L12.875 14",
    stroke: "currentColor",
    strokeWidth: 1.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.37f57c004e6e8060f3583caa64bda2b3.svg";
export { ForwardRef as ReactComponent };